import handle from './handle';

export default [handle];
